import { NavLink } from "react-router-dom";
import { cx } from "./cx";
import styles from "./Tabs.module.css";

export type TabItem = {
  to: string;
  label: string;
  /** Correspondance exacte, pour l'onglet dont le chemin préfixe les autres. */
  end?: boolean;
};

export type TabsProps = {
  items: TabItem[];
  /** Nom de la navigation pour l'assistance technique : « Sections des paramètres ». */
  label: string;
  className?: string;
};

/**
 * Onglets de navigation entre les sous-pages d'un écran.
 *
 * Ce sont des liens, pas un `tablist` : chaque onglet a son URL, s'ouvre dans
 * un nouvel onglet du navigateur et survit à un rechargement.
 */
export function Tabs({ items, label, className }: TabsProps) {
  return (
    <nav aria-label={label} className={cx(styles.onglets, className)}>
      {items.map((o) => (
        <NavLink key={o.to} to={o.to} end={o.end} className={({ isActive }) => cx(styles.onglet, isActive && styles.actif)}>
          {o.label}
        </NavLink>
      ))}
    </nav>
  );
}
